/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-admin-program-catalog';

type Props = {
  open: boolean;
  onClose: () => void;
};

export const DynamicCollectionDialog = (props: Props): React.ReactElement => {
  const { open, onClose } = props;

  return (
    <Dialog open={open} onClose={onClose}>
      <Dialog.HeadingGroup>{_t('Dynamic Collection')}</Dialog.HeadingGroup>
      <Dialog.Content
        css={css`
          display: flex;
          flex-direction: column;
          gap: var(--cds-spacing-200);
        `}
      >
        <Typography2 component="p">
          {_t(
            'Dynamic collections are updated regularly by our in house team of experts. This option is ideal for keeping your learning content up-to-date without manual intervention.'
          )}
        </Typography2>
        <Typography2 component="p">
          {_t(
            'While you have the flexibility to edit and customize the content, if you make any changes, the collection will convert to a custom collection and will no longer receive automatic updates.'
          )}
        </Typography2>
      </Dialog.Content>
      <Dialog.Actions>
        <Button variant="secondary" onClick={onClose}>
          {_t('Close')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default DynamicCollectionDialog;
